<template>
  <section class="serviceCenter pt-6 pb-18 bg-white">
    <div>
      <div v-if="!topPage" class="fixed bottom-4 right-4 cursor-pointer hidden md:block" @click.prevent="scrollToTop">
        <ArrowUpCircleIcon
          class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor"
          aria-hidden="true"
        />
      </div>

      <div class="mx-auto w-10/12">
        <div class="grid auto-rows-auto">
          <h1 class="font-bold text-xxl flex text-pdsPrimaryColor mt-0">Service en contact</h1>
          <h3 class="mb-4 font-bold text-xl flex text-pdsPrimaryColor">Waarmee kunnen we u helpen</h3>
        </div>
        <div class="grid grid-rows lg:grid-cols-2 gap-4">
          <div
            v-for="(serviceItem, index) in serviceCenterDetails.informationBlock.informationTypes"
            :key="index"
            class="card shadow rounded border border-balternative-color"
          >
            <div class="flex flex-cols-2">
              <div class="justify-self-start ml-4 mt-1 lg:mt-0">
                <QuestionMarkCircleIcon
                  v-if="serviceItem.type === 'Question'"
                  class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor my-4 mr-2"
                  aria-hidden="true"
                />
                <PlayCircleIcon
                  v-if="serviceItem.type === 'Video'"
                  class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor my-4 mr-2"
                  aria-hidden="true"
                />

                <PhoneIcon
                  v-if="serviceItem.type === 'Contact'"
                  class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor my-4 mr-2"
                  aria-hidden="true"
                />
                <EnvelopeIcon
                  v-if="serviceItem.type === 'Message'"
                  class="h-5 md:h-7 lg:h-7 w-5 md:w-7 lg:w-7 inline-block text-pdsPrimaryColor cursor my-4 mr-2"
                  aria-hidden="true"
                />
              </div>
              <div class="">
                <h3 class="my-4 font-bold text-xl mr-2">{{ serviceItem.header }}</h3>
                <p class="pr-8">{{ serviceItem.text }}</p>
              </div>
            </div>
            <button
              @click.prevent="$router.push('#' + serviceItem.type)"
              class="flex self-end mt-4 lg:mt-0 mb-6 mr-4 justify-self-end justify-center py-2 px-2 md:px-4 border border-primary-color shadow-sm text-xs md:text-sm lg:text-sm font-medium text-primary-color bg-white rounded-full hover:bg-primary-default/50 items-center"
            >
              <span class="font-bold"> {{ serviceItem.buttonText }}</span>
              <ArrowRightIcon class="h-5 w-5 flex-shrink-0 ml-2 text-primary-default" aria-hidden="true" />
            </button>
          </div>
        </div>
        <div class="grid auto-rows-auto mt-4 gap-4 pb-32">
          <div class="shadow bg-white rounded border broder-bdefault" v-if="siteCode" id="Question">
            <h1 class="py-4 px-6 font-bold text-xl flex text-pdsPrimaryColor bg-balternative-color my-0">
              Veelgestelde vragen
            </h1>
            <faqs />
          </div>
          <div id="Video" class="shadow bg-white rounded border broder-bdefault">
            <h1 class="py-4 px-6 font-bold text-xl flex text-pdsPrimaryColor bg-balternative-color my-0">
              Instructievideo van het voorschrijfsysteem
            </h1>
            <div class="px-6 pt-2 pb-6 text-pdsPrimaryColor">
              <h4 class="py-2">Instructievideo\'s over het gebruik van de infuuspompen</h4>
              <p class="py-2">
                Wilt u meer weten over het gebruik van de infuuspompen die u bij Mediq kan aanvragen? We hebben
                instructievideo's ontwikkeld voor de infuuspompen CADD Solis, <br />
                Medcaptain en Bodyguard. In deze instructievideo's wordt stap voor stap aan u de belangrijkste
                handelingen uitgelegd.
              </p>
              <p class="py-2 font-bold">
                <a
                  href="https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmediq.flowsparks.com%2FLogin%2Fmediq%2FExternalContentAccess%3Flogin%3DN2RiZmFiNDAtMzg4Yi00YmM2LTgxMDAtYWM4MmRhYmIyZjQxOjExMDM1MTo0MzcxZDU3Yy1jNjQ0LTQ5Y2ItODJlNC00YTE1YTZmZDcyNjc%253d%26Lang%3Dnl&amp;data=05%7C02%7Colaf.donders%40flowsparks.com%7C64616465e39a445046ae08dbffd80e52%7C603cc6d965b4492dbe8995d5071203ce%7C1%7C0%7C638385075671049505%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C3000%7C%7C%7C&amp;sdata=rczCBe8r3Ds6Fs0LaAT9G%2BC%2B6S%2Fa2anjtUILZ20PJ9k%3D&amp;reserved=0\"
                  target="_blank"
                >
                  <span class="underline">Bekijk hier de pompen instructie video's</span>
                </a>
              </p>
              <h4 class="py-2 font-bold">Wegwijzers � download</h4>
              <p class="py-2">
                Alle belangrijkste handelingen staat ook voor u uitgeschreven in een handige wegwijzer. De wegwijzer is
                voorzien van duidelijke screenshots en er is per behandelgebied een specifieke versie beschikbaar.
              </p>
              <p class="py-2">
                Per behandelgebied worden de belangrijkste functionaliteiten extra uitgelicht. Selecteer het
                behandelgebied wat voor u van toepassing is om de wegwijzer te
                <a href="https://infuus.mediq.nl/attachments/Wegwijzer-voorschijfportaal.pdf" target="_blank">
                  <span class="underline font-bold"> downloaden</span>.
                </a>
              </p>
              <p class="py-2 font-bold">
                <a
                  href="https://infuus.mediq.nl/attachments/0496V1-Infuus-Overzicht-aanvraagform-A4-Cert.pdf"
                  target="_blank"
                >
                  <span class="underline">Overzicht beschikbare aanvraagformulieren Infuustherapie</span>
                </a>
              </p>
              <p class="py-2 font-bold">
                <a href="https://infuus.mediq.nl/attachments/Werkwijzer_Infuus_PatientoverdragenV4.pdf" target="_blank">
                  <span class="underline"> Wegwijzer pati�nt overdragen Infuustherapie </span>
                </a>
              </p>
              <p class="py-2 font-bold">
                <a href="https://youtu.be/95F0Z2esR6M" target="_blank">
                  <span class="underline"> Link naar instructievideo Bestelling afronden </span>
                </a>
              </p>
              <p class="py-2 font-bold">
                <a href="https://youtu.be/4lEqJz1suq8" target="_blank">
                  <span class="underline"> Link naar instructievideo Catalogus</span>
                </a>
              </p>
              <p class="py-2 font-bold">
                <a href="https://youtu.be/tsw7Y1ntLlc" target="_blank">
                  <span class="underline"> Link naar instructievideo Navigatie </span>
                </a>
              </p>
              <p class="py-2 font-bold">
                <a href="https://youtu.be/U-i1JFi4kpc" target="_blank">
                  <span class="underline"> Link naar instructievideo "Pati�ntdashboard"</span>
                </a>
              </p>
            </div>
          </div>
          <div id="Contact" class="shadow bg-white rounded border broder-bdefault">
            <contact-details />
          </div>
          <div id="Message" class="shadow bg-white rounded border broder-bdefault">
            <contact />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Contact from '@/components/sections/contact/Contact';
import ContactDetails from '@/components/sections/contact/ContactDetails';
import faqs from '@/components/sections/serviceCenter/faqs.vue';
import { useStore } from 'vuex';
import { computed, onUnmounted, onMounted, ref } from 'vue';
import {
  ArrowUpCircleIcon,
  PhoneIcon,
  EnvelopeIcon,
  PlayCircleIcon,
  QuestionMarkCircleIcon,
  ArrowRightIcon
} from '@heroicons/vue/20/solid';

export default {
  name: 'ServiceCenter',
  components: {
    faqs,
    Contact,
    ContactDetails,
    PhoneIcon,
    EnvelopeIcon,
    PlayCircleIcon,
    QuestionMarkCircleIcon,
    ArrowUpCircleIcon,
    ArrowRightIcon
  },
  setup() {
    const store = useStore();
    const siteCode = computed(() => store.getters['navigation/getSiteCode']);
    const topPage = ref(false);
    const serviceCenterDetails = {
      informationBlock: {
        informationTypes: [
          {
            header: 'Ik heb een vraag',
            text: 'We hebben veel vragen en antwoorden voor u verzameld in onze hulprubriek',
            type: 'Question',
            buttonText: 'Bekijk veelgestelde vragen'
          },
          {
            header: 'Instructievideo en handleidingen voor het Mediq voorschrijfsysteem',
            text: 'Deze video laat u de belangrijkste handelingen zien, zodat u snel en efficient patienten kunt zoeken en aanmelden, bestellingen kunt plaatsen en machtigingen kunt afgeven.',
            type: 'Video',
            buttonText: 'Bekijk instructievideo'
          },
          {
            header: 'Liever telefonisch contact?',
            text: 'Staat uw vraag niet in onze hulprubriek? Wij staan graag voor u klaar',
            type: 'Contact',
            buttonText: 'Bel ons'
          },
          {
            header: 'Stuur ons een bericht',
            text: 'Stel uw vraag via het contactformulier',
            type: 'Message',
            buttonText: 'Stuur bericht'
          }
        ]
      }
    };

    const topVisible = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      return scrollY === 0;
    };

    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };

    onMounted(() => {
      window.addEventListener('scroll', () => {
        topPage.value = topVisible();
      });
    });

    onUnmounted(() => {
      store.commit('patient/setPatientGegevens', {});
    });

    return {
      topVisible,
      scrollToTop,
      topPage,
      serviceCenterDetails,
      siteCode
    };
  }
};
</script>
